import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionJuradaCeseActividadParcialByID = () => {
  const [loadingUpdateDeclaracionJuradaCeseActividadParcialById, setLoadingCreateDeclaracionJuradaCeseActividadParcial] = useState(false);
  const [successUpdateDeclaracionJuradaCeseActividadParcialById, setSuccessCreateDeclaracionJuradaCeseActividadParcial] = useState(false);
  const [errorUpdateDeclaracionJuradaCeseActividadParcialById, setErrorCreateDeclaracionJuradaCeseActividadParcial] = useState(null);
  const [dataUpdateDeclaracionJuradaCeseActividadParcialById, setDataDeclaracionJuradaCeseActividadParcial] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateDeclaracionJuradaCeseActividadParcialById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateDeclaracionJuradaCeseActividadParcial(true);
    setSuccessCreateDeclaracionJuradaCeseActividadParcial(false);
    setErrorCreateDeclaracionJuradaCeseActividadParcial(null);

    apiRecord.updateSolicitudDeclaracionJuradaParcialByID(userId, formId, data).then((res: any) => {
      setLoadingCreateDeclaracionJuradaCeseActividadParcial(false);
      setSuccessCreateDeclaracionJuradaCeseActividadParcial(true);
      setDataDeclaracionJuradaCeseActividadParcial(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateDeclaracionJuradaCeseActividadParcial(false);
      setErrorCreateDeclaracionJuradaCeseActividadParcial(err.response.data)
    })
  }

  return {
    updateDeclaracionJuradaCeseActividadParcialById,
    loadingUpdateDeclaracionJuradaCeseActividadParcialById,
    successUpdateDeclaracionJuradaCeseActividadParcialById,
    errorUpdateDeclaracionJuradaCeseActividadParcialById,
    dataUpdateDeclaracionJuradaCeseActividadParcialById
  }

}

export default useUpdateDeclaracionJuradaCeseActividadParcialByID;
